"use client";

import { cn } from "@/lib/utils";

interface ParameterTableProps {
  headers: string[];
  rows: React.ReactNode[][];
  className?: string;
}

export function ParameterTable({
  headers,
  rows,
  className,
}: ParameterTableProps) {
  return (
    <div className={cn("overflow-x-auto rounded-lg border border-border", className)}>
      <table className="w-full text-sm">
        <thead className="bg-primary/10 text-left font-medium text-foreground">
          <tr>
            {headers.map((header, index) => (
              <th
                key={index}
                className="whitespace-nowrap px-2 py-2 font-semibold sm:px-4 sm:py-3"
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-border">
          {rows.map((row, rowIndex) => (
            <tr key={rowIndex} className="bg-card">
              {row.map((cell, cellIndex) => (
                <td
                  key={cellIndex}
                  className="px-2 py-2 text-muted-foreground sm:px-4 sm:py-3"
                >
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
